module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 010.83dfb898.jpg";